// store/actions.js
export default {
  setLoading({ commit }, isLoading) {
    commit('setLoading', isLoading);
  },
};
